import React from "react";
import { FormControl, ControlLabel } from "react-bootstrap";
import ajax from "./../../lib/ajax.js";
import context from "./../../lib/context.js";
import ReactDOM from 'react-dom';

export default class Company extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            companies: []
        };

        this.loadCompanies = this.loadCompanies.bind(this);
        this.onChange = this.onChange.bind(this);
    }    

    componentDidMount() {
        this.loadCompanies();
    }

    loadCompanies() {
        let self = this;
        ajax.api().get("get-companies")
            .then(function (res) {
                self.setState({ companies: res.data });
            })
            .catch(function (err) {
                let data = err.response.data;
                context.message({
                    show: true,
                    type: "error",
                    message: data.exceptionMessage || data.message,
                    buttons: "close"
                });
            });
    }

    onChange(event) {
        var description = '';
        var company = this.state.companies.filter(x => x.code == event.target.value);

        if (company.length > 0) {
            description = company[0].description;
        }

        if (this.props.onChange)
            this.props.onChange(event.target.value, description);
    }

    render() {
        var companies = [];
        var allText = 'All';
        var useCodeDescription = false;
        var readOnly = false;

        if (this.props.allText !== undefined)
            allText = this.props.allText;

        if (this.props.useCodeDescription !== undefined)
            useCodeDescription = this.props.useCodeDescription;

        if (this.props.readOnly !== undefined)
            readOnly = this.props.readOnly

        companies.push(<option key="All" value="" selected="true">{allText}</option>);

        const self = this;
        var description = '';

        this.state.companies.map(function (item, i) {
            if (useCodeDescription == true) {
                companies.push(<option key={item.code} value={item.code}>{item.code + '-' + item.description}</option>)
            }
            else {
                companies.push(<option key={item.code} value={item.code}>{item.description}</option>)
            }

            if (self.props.value == item.code)
                description = useCodeDescription == true ? item.code + '-' + item.description : item.description;
        }, this);

        return (   
            <div className="ap-report-control-dropdown">
                {
                    this.props.readOnly == false ?
                        <FormControl
                            id={this.props.id + '-select'}
                            componentClass="select"
                            value={this.props.value}
                            onChange={this.onChange}
                            inputRef={el => this.inputEl = el}
                            className={this.props.className}
                            readOnly={this.props.readOnly}>
                            {companies}
                        </FormControl> :
                        <div><ControlLabel className="ap-report-control-label ap-black-color">{description}</ControlLabel></div>
                }
                
            </div>
        );
    }
}